'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EVENTS = exports.EVENTS = {
  CLICK: 'CLICK'
};

var TYPES = exports.TYPES = {
  LISTING: 'LISTING',
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};

var CONTEXTS = exports.CONTEXTS = {
  HOME: 'HOME',
  LISTING_DETAILS: 'LISTING_DETAILS'
};

var VALUES = exports.VALUES = {
  CATEGORY: 'CATEGORY'
};

var APPLICATION_NAME = exports.APPLICATION_NAME = 'appcenter';

var elementList = exports.elementList = {
  button: 'button',
  link: 'link',
  menuItem: 'menuitem'
};

var actionList = exports.actionList = {
  click: 'click'
};

var termsAndConditions = exports.termsAndConditions = 'Terms and Conditions Panel';

var button = exports.button = {
  accept: 'accept',
  cancel: 'cancel',
  connect: 'connect',
  disconnect: 'disconnect',
  enroll: 'enroll',
  unenroll: 'unenroll',
  yes: 'yes',
  no: 'no',
  x: 'close'
};

var modal = exports.modal = {
  enroll: 'enroll modal',
  unenroll: 'unenroll modal',
  disconnect: 'disconnect modal'
};

var connectLoyaltyNumber = exports.connectLoyaltyNumber = 'Connect Loyalty Number section';

var needAnAccountLink = exports.needAnAccountLink = 'Need an Account Link';

var learnMoreSharedInfoLink = exports.learnMoreSharedInfoLink = 'Learn more about the services and fields exposed.';

var ReqInfo = exports.ReqInfo = 'Request Information';

var launchTAndC = exports.launchTAndC = 'Launch Terms and Conditions Panel';

var connectWithoutTAndC = exports.connectWithoutTAndC = 'Connect without launching Terms and Conditions Panel';

var listingConst = exports.listingConst = 'listing';

var categoryDropdown = exports.categoryDropdown = 'Category Dropdown Menu Option';


//////////////////
// WEBPACK FOOTER
// ./lib/constants/analytics.js
// module id = 43
// module chunks = 0